import { Button, Flex, TextInput } from "@mantine/core";
import Container from "../components/common/Container";
import PageHeader from "../components/common/PageHeader";
import { useForm } from "@mantine/form";
import styled from "styled-components";
import { validateRequired, validateSchedule } from "../utils/validations";
import { createDepartment } from "../api/departmentApi";
import { creationNotification } from "../utils/useNotification";
import { useAuth } from "../context/AuthContext";
import WeeklySchedule from "../components/common/WeeklyWorkTimePlan";
import PlusIcon from "../components/common/Icons/PlusIcon";
import { useRef } from "react";
import dayjs from "dayjs";

const NewDepartment = () => {
  const { refetchDepartmentSelectData, company } = useAuth();
  const formRef = useRef<HTMLFormElement>(null);

  // 0 = Pazar, 6 = Cumartesi
  const defaultWorkHours = Array(7)
    .fill(null)
    .reduce((acc, _, index) => {
      acc[index] = {
        enabled: false,
        start: "",
        duration: 0,
        end: "",
      };
      return acc;
    }, {} as Record<number, any>);

  const form = useForm<any>({
    initialValues: {
      name: "",
      description: "",
      workHours: defaultWorkHours,
    },
    validate: {
      name: validateRequired,
      description: validateRequired,
      workHours: validateSchedule,
    },
  });

  const handleSubmit = async (values: any) => {
    function timeStrToLocalDateTime(timeStr: any): any {
      const today = dayjs();
      const [hour, minute] = timeStr.split(":").map(Number);
      return today.hour(hour).minute(minute).second(0).millisecond(0).toDate();
    }

    const transformed = Object.entries(values.workHours).reduce(
      (acc, [key, value]: any) => {
        if (value.start && value.end) {
          acc[key] = {
            start: timeStrToLocalDateTime(value.start),
            end: timeStrToLocalDateTime(value.end),
          };
        } else {
          acc[key] = {};
        }
        return acc;
      },
      {} as Record<string, { start?: string; end?: string }>
    );
    try {
      const { data, response }: any = await createDepartment({
        ...values,
        workHours: transformed,
      });

      if (data?.success) {
        creationNotification("Departman", data.success);
        refetchDepartmentSelectData();
        form.reset();
        return;
      }

      if (response?.data?.error) {
        alert(response?.data.error);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  return (
    <Container>
      <PageHeader
        pageTitle="Yeni Departman Kaydı"
        isButtoned
        buttonText="Oluştur"
        buttonIcon={<PlusIcon />}
        buttonOnClick={() => formRef.current?.requestSubmit()}
      />
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "40px",
        }}
      >
        <form
          ref={formRef}
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "24px",
          }}
          onSubmit={form.onSubmit(handleSubmit)}
        >
          <Flex gap={12} flex={1}>
            <TextInput
              label="Departman İsmi"
              placeholder="Departman İsmi Giriniz."
              radius={10}
              maxLength={40}
              w={"50%"}
              size="md"
              {...form.getInputProps("name")}
            />
            <TextInput
              label="Departman Açıklaması"
              placeholder="Departman Açıklaması Giriniz."
              radius={10}
              maxLength={150}
              w={"50%"}
              size="md"
              {...form.getInputProps("description")}
            />
          </Flex>

          {company?.modules?.isDepartmentWorkHoursAvailable && (
            <Flex flex={1}>
              <WeeklySchedule
                value={Object.values(form.values.workHours)}
                onChange={(updatedObject: any) => {
                  form.setFieldValue("workHours", updatedObject);
                }}
                error={form.errors.workHours}
              />
            </Flex>
          )}
        </form>
      </div>
    </Container>
  );
};

export default NewDepartment;
